export type FeatureMapping = Record<string, { resources: Array<string>, description: 'string' }>;
